import React from 'react';
import {useTranslation} from 'react-i18next';
import {ViewMode} from '@taopix/taopix-core';
import {Button} from '@taopix/taopix-design-system';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';

export type ShowMoreButtonProps = {
  pageNumber: number;
  enabled: boolean;
  classNames: string;
  icon: React.ReactElement;
};

const ShowMoreButton = ({pageNumber, enabled, classNames, icon}: ShowMoreButtonProps) => {
  const ui = useUiState();
  const {t} = useTranslation();
  return (
    <Button
      label={t('stubar:str_LabelPageOptions')}
      hideLabel
      endIcon={icon}
      buttonStyle={'distinct'}
      id={`editPageButton-${ui.state.pageNumber}`}
      size={ui.state.viewMode === ViewMode.Grid && ui.state.isSmallScreen ? 'xsmall' : 'small'}
      aria-pressed={
        ui.state.palette.section?.includes('pageActionsPalette') &&
        ui.state.pageNumber === pageNumber
      }
      onClick={() => {
        if (
          !ui.state.palette.section?.includes('pageActionsPalette') ||
          (ui.state.palette.section?.includes('pageActionsPalette') &&
            ui.state.pageNumber !== pageNumber)
        ) {
          // If the palette isn't open or its open for a different page, set the page number and open the palette
          ui.dispatch(UserInterfaceActions.setPageNumber(pageNumber));
          ui.dispatch(UserInterfaceActions.setToolPaletteSection('pageActionsPalette'));
        } else {
          ui.dispatch(UserInterfaceActions.setToolPaletteSection(null));
        }
      }}
      className={classNames}
      disabled={!enabled || ui.state.focusMode}
    />
  );
};

export default ShowMoreButton;
